import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactCard = () => {
    const { t } = useTranslation();
    return (
        <div className="mt-8">
            <h2 className="text-sm font-semibold text-primary">{t("HELP_CONTACT_LABEL")}</h2>
            <div className="mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-[0_8px_20px_rgba(15,23,42,0.06)]">
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                        <p className="text-sm font-semibold text-slate-900">{t("HELP_CONTACT_TITLE")}</p>
                        <p className="mt-2 text-sm text-slate-500">
                            {t("HELP_CONTACT_DESCRIPTION")}
                        </p>
                    </div>
                    <Link
                        to="/help/contact"
                        className="inline-flex items-center gap-1 text-xs font-semibold text-primary underline underline-offset-4"
                    >
                        {t("HELP_CONTACT_CTA")}
                        <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ContactCard;
